import React, { useState } from 'react';
import './SelectField.css';

interface SelectFieldProps {
    value: string | number;
    onChange: (value: string | number) => void;
    label?: string;
    placeholder?: string;
    error?: string;
    disabled?: boolean;
    required?: boolean;
    className?: string;
    style?: React.CSSProperties;
    children: React.ReactNode;
    size?: 'small' | 'medium' | 'large';
    onFocus?: () => void;
    onBlur?: () => void;
}

const SelectField: React.FC<SelectFieldProps> = ({
    value,
    onChange,
    label,
    placeholder,
    error,
    disabled = false,
    required = false,
    className = '',
    style,
    children,
    size = 'medium',
    onFocus,
    onBlur
}) => {
    const [isFocused, setIsFocused] = useState(false);

    const handleFocus = () => {
        setIsFocused(true);
        if (onFocus) onFocus();
    };

    const handleBlur = () => {
        setIsFocused(false);
        if (onBlur) onBlur();
    };

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        onChange(e.target.value);
    };

    return (
        <div className={`select-field-container ${className} ${error ? 'error' : ''} ${disabled ? 'disabled' : ''} ${size}`}>
            {label && (
                <label className="select-field-label floating">
                    {label}
                </label>
            )}
            <div className="select-field-wrapper">
                <select
                    value={value}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    disabled={disabled}
                    required={required}
                    className={`select-field ${isFocused ? 'focused' : ''}`}
                    style={style}
                >
                    {placeholder && (
                        <option value="" disabled>
                            {placeholder}
                        </option>
                    )}
                    {children}
                </select>
                <div className="select-field-arrow">
                    <i className="fas fa-chevron-down"></i>
                </div>
            </div>
            {error && (
                <div className="select-field-error">
                    {error}
                </div>
            )}
        </div>
    );
};

export default SelectField;
